import * as Types from '../../../App/AppPageBlock/graphql/hirer-types.generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SalaryQuestionnaireQueryVariables = Types.Exact<{
  questionnaireId: Types.Scalars['String']['input'];
  adcentreAdvertiserId: Types.Scalars['String']['input'];
}>;

export type SalaryQuestionnaireQuery = {
  __typename: 'Query';
  questionnaire: {
    __typename: 'Questionnaire';
    salaryQuestions?: Array<{
      __typename: 'QuestionnaireQuestion';
      globalId?: string | null;
    }> | null;
  };
};

export const SalaryQuestionnaireDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SalaryQuestionnaire' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'questionnaireId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'adcentreAdvertiserId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'questionnaireId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'adcentreAdvertiserId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'adcentreAdvertiserId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'salaryQuestions' },
                  name: { kind: 'Name', value: 'questions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'input' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'category' },
                            value: { kind: 'EnumValue', value: 'SALARY' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'globalId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSalaryQuestionnaireQuery__
 *
 * To run a query within a React component, call `useSalaryQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalaryQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalaryQuestionnaireQuery({
 *   variables: {
 *      questionnaireId: // value for 'questionnaireId'
 *      adcentreAdvertiserId: // value for 'adcentreAdvertiserId'
 *   },
 * });
 */
export function useSalaryQuestionnaireQuery(
  baseOptions: Apollo.QueryHookOptions<
    SalaryQuestionnaireQuery,
    SalaryQuestionnaireQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SalaryQuestionnaireQuery,
    SalaryQuestionnaireQueryVariables
  >(SalaryQuestionnaireDocument, options);
}
export function useSalaryQuestionnaireLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SalaryQuestionnaireQuery,
    SalaryQuestionnaireQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SalaryQuestionnaireQuery,
    SalaryQuestionnaireQueryVariables
  >(SalaryQuestionnaireDocument, options);
}
export type SalaryQuestionnaireQueryHookResult = ReturnType<
  typeof useSalaryQuestionnaireQuery
>;
export type SalaryQuestionnaireLazyQueryHookResult = ReturnType<
  typeof useSalaryQuestionnaireLazyQuery
>;
export type SalaryQuestionnaireQueryResult = Apollo.QueryResult<
  SalaryQuestionnaireQuery,
  SalaryQuestionnaireQueryVariables
>;
